<norupe-header />
<section class="absolute top-16 bottom-0 w-full overflow-hidden">
  <div
    class="relative h-[50%] w-full overflow-x-hidden border-b border-gray-200 px-4 py-6 sm:px-6 md:float-left md:h-full md:w-lg md:border-r md:border-b-0 md:pl-6"
  >
    <router-outlet />
  </div>

  <article class="relative h-[50%] w-full overflow-x-hidden md:h-full md:w-auto md:overflow-hidden">
    <ngx-ol-map
      #map
      height="100%"
      style="height: 100%; width: 100%"
      width="100%"
      (initialize)="selectedTerritoriesVectorTileLayer($event)"
      (olSingleClick)="selectedObject($event)"
    >
      <ngx-ol-overlay positioning="top-center" [element]="popup" [offset]="[0, 30]" [position]="overlayPosition()" />
      <ngx-ol-view [center]="[2743111, 7726146]" [enableRotation]="true" [rotation]="0.75" [zoom]="18" (olChangeResolution)="updateStoreZoom()" />

      <ngx-ol-control-full-screen />
      <ngx-ol-control-scale-line />
      <ngx-ol-control-zoom-slider />

      <ngx-ol-layer-tile>
        <ngx-ol-source-osm />
      </ngx-ol-layer-tile>

      @if (router.url.includes("/seeding")) {
        <ngx-ol-layer-vector-tile #territoriesLayer [style]="territorySlotsStyle()">
          <ngx-ol-source-vector-tile #slotsSource [format]="MVT" [url]="territoriesSlotURL" />
        </ngx-ol-layer-vector-tile>
        @if (this.mapStore.showSelectionControl()) {
          <norupe-selector-control
            context="seeding"
            [map]="this.map"
            [selectedTerritoriesLayer]="this.selectedTerritoriesLayer"
            [territoriesLayer]="this.territoriesLayer"
          />
        }
      } @else {
        <ngx-ol-layer-vector-tile #territoriesLayer [style]="territoryStyle()">
          <ngx-ol-source-vector-tile [format]="MVT" [url]="territoiesAndSlotsURL" />
        </ngx-ol-layer-vector-tile>
        @if (this.mapStore.showSelectionControl()) {
          <norupe-selector-control
            context="territory"
            [map]="this.map"
            [selectedTerritoriesLayer]="this.selectedTerritoriesLayer"
            [territoriesLayer]="this.territoriesLayer"
          />
        }
      }
    </ngx-ol-map>
  </article>
</section>
<div #popup class="min-w-36 rounded-sm border bg-white p-2 px-4 pt-5 text-sm dark:bg-slate-900 dark:text-white">
  <div class="absolute top-0 right-0 hidden pt-2 pr-2 sm:block">
    <button
      type="button"
      class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
      (click)="closePopup()"
    >
      <span class="sr-only">Close</span>
      <svg data-slot="icon" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" class="size-6" aria-hidden="true">
        <path d="M6 18 18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
  @if (featureOnCursor().length > 0) {
    <div class="divide-y">
      @for (feature of featureOnCursor(); track feature.getId()) {
        <div class="py-3">
          <div>
            <div class="flex items-center">
              <h3 class="mr-2 text-xl font-bold text-gray-900 sm:text-2xl dark:text-gray-100">
                {{ feature.get("name") }}
              </h3>
              <norupe-color-switcher class="ml-auto" [feature]="feature" />
            </div>
            <p class="text-sm text-gray-500">
              {{ feature.get("id") }}
            </p>
          </div>
          @let jobsList = jobListByTerritor(feature.get("id"));
          @defer (when (jobsList ?? []).length > 0) {
            <ul role="list" class="max-h-64 divide-y divide-gray-100 overflow-y-auto border-t border-gray-400 pt-2">
              @for (item of jobsList; track $index) {
                <norupe-job-item [item]="item" />
              }
            </ul>
          }
          <div *hasRole="['admin', 'manager']" class="mt-5 flex flex-wrap space-y-3 sm:space-y-0 sm:space-x-3">
            @if ((router.url.includes("job/new") || router.url.includes("edit")) && !router.url.includes("/seeding")) {
              <button
                type="button"
                class="inline-flex w-full shrink-0 items-center justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:flex-1"
                (click)="this.mapStore.toggleSelectedTerritory(feature.get('id'))"
              >
                @if (this.mapStore.selectedTerritoriesIds().has(feature.get("id"))) {
                  <svg data-slot="icon" fill="currentColor" viewBox="0 0 20 20" class="-ml-1.5 size-5" aria-hidden="true">
                    <path d="M6.75 9.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z" />
                  </svg>
                  {{ "JOB.remove_territory" | translate }}
                } @else {
                  <svg data-slot="icon" fill="currentColor" viewBox="0 0 20 20" class="-ml-1.5 size-5" aria-hidden="true">
                    <path
                      d="M10.75 6.75a.75.75 0 0 0-1.5 0v2.5h-2.5a.75.75 0 0 0 0 1.5h2.5v2.5a.75.75 0 0 0 1.5 0v-2.5h2.5a.75.75 0 0 0 0-1.5h-2.5v-2.5Z"
                    />
                  </svg>
                  {{ "JOB.add_territory" | translate }}
                }
              </button>
            } @else {
              <button
                type="button"
                class="inline-flex w-full shrink-0 items-center justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:flex-1"
                [queryParams]="{ territories: feature.get('id') }"
                [routerLink]="['/job/new']"
                (click)="overlayPosition.set([0, 0])"
              >
                <svg data-slot="icon" fill="currentColor" viewBox="0 0 20 20" class="-ml-1.5 size-5" aria-hidden="true">
                  <path
                    d="M10.75 6.75a.75.75 0 0 0-1.5 0v2.5h-2.5a.75.75 0 0 0 0 1.5h2.5v2.5a.75.75 0 0 0 1.5 0v-2.5h2.5a.75.75 0 0 0 0-1.5h-2.5v-2.5Z"
                  />
                </svg>
                {{ "JOB.new" | translate }}
              </button>
            }
            <!-- <button
                  type="button"
                  class="shadow-xs inline-flex w-full flex-1 items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  [routerLink]="['/territory', feature.get('id')]"
                >
                  {{ 'JOB.views' | translate}}
                </button> -->
          </div>
        </div>
      }
    </div>
  }
</div>
